module.exports = __webpack_public_path__ + "static/img/increase-lead-handover01.dd8248e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/increase-lead-handover01.png
// module id = Q9ES
// module chunks = 1